import React from 'react'
import PropTypes from 'prop-types'
import {
  CCard,
  CCardBody,

} from '@coreui/react'

import { DocsExample } from '../../components'


const Widgets = ({ data, onFrameClick, onOpenDetails }) => {
  // const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

  return (
    <CCard className="">

      <CCardBody className='quitar-padding'>

        <DocsExample
          data={data}
          href="components/widgets/#cwidgetstatsd"
          onFrameClick={onFrameClick}
          onOpenDetails={onOpenDetails}
        >
        </DocsExample >

      </CCardBody>
    </CCard>
  )
}

Widgets.propTypes = {
  data: PropTypes.array,
  onFrameClick: PropTypes.func,
  onOpenDetails: PropTypes.func,
}

export default Widgets
